import { render, staticRenderFns } from "./Samedia.vue?vue&type=template&id=1d8c2c1d&lang=pug"
import script from "./Samedia.vue?vue&type=script&lang=js"
export * from "./Samedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports